import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';

const CheckCircleOutline = (): JSX.Element => <CheckCircleOutlineIcon fontSize="inherit" />;

export default CheckCircleOutline;
